// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee7aa6a6","455":"100dec5a","977":"21793a31"}[chunkId] + ".chunk.js";
};